export default __webpack_public_path__ + "static/media/no.8c1e4da4.svg";